import styled from "styled-components";

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 10px;
`

export const Button = styled.div`
    width: 32px;
    height: 32px;
    display: flex;
    border-radius: 100px;
    background: #121620;
    align-items: center;
    justify-content: center;
`